import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';
const AuthContext = createContext(null);
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const token = localStorage.getItem('comoticket_token');
    const savedUser = localStorage.getItem('comoticket_user');
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);
  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    return res.data;
  };
  const verifyCode = async (user_id, code) => {
    const res = await api.post('/auth/verify-2fa', { user_id, code });
    localStorage.setItem('comoticket_token', res.data.token);
    localStorage.setItem('comoticket_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };
  const resendCode = async (user_id) => {
    const res = await api.post('/auth/resend-2fa', { user_id });
    return res.data;
  };
  const logout = () => {
    localStorage.removeItem('comoticket_token');
    localStorage.removeItem('comoticket_user');
    setUser(null);
  };
  return (
    <AuthContext.Provider value={{ user, login, verifyCode, resendCode, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
export const useAuth = () => useContext(AuthContext);